import { render, staticRenderFns } from "./EditTechDataModal.vue?vue&type=template&id=ec6c636a&scoped=true"
import script from "./EditTechDataModal.vue?vue&type=script&lang=js"
export * from "./EditTechDataModal.vue?vue&type=script&lang=js"
import style0 from "./EditTechDataModal.vue?vue&type=style&index=0&id=ec6c636a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6c636a",
  null
  
)

export default component.exports